import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { DefaultApolloClient } from '@vue/apollo-composable';
import App from './App.vue';
import router from './router/index';
import { i18n } from './i18n/index';
import { apolloClient } from '@service/apollo';
import { initKeycloak } from '@service/keycloak/keycloak';
import { notifier } from '@service/notifier';
import './main.css';

async function bootstrap() {
  const app = createApp(App);
  const pinia = createPinia();

  app.use(pinia);
  app.use(i18n);
  app.use(router);
  app.provide(DefaultApolloClient, apolloClient);

  app.config.errorHandler = (error, _instance, info) => {
    console.error('Vue error', error, info);
    notifier.error(error instanceof Error ? error.message : 'ERROR.generic');
  };

  try {
    await initKeycloak();
  } catch (error) {
    console.error(error);
    app.mount('#app');
    void router.replace({ name: 'unauthorized' });
    return;
  }

  app.mount('#app');
}

void bootstrap();
